import { useTheme } from "./ThemeContext";
import Icon from "@/components/Icon";

/** Petit bouton de bascule clair/sombre, réutilisable dans les en-têtes. */
export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      title={isDark ? "Passer en mode clair" : "Passer en mode sombre"}
      aria-label={isDark ? "Passer en mode clair" : "Passer en mode sombre"}
      style={styles.btn}
    >
      <Icon name={isDark ? "light" : "dark"} size={16} />
    </button>
  );
}

const styles: Record<string, React.CSSProperties> = {
  btn: {
    background: "transparent",
    border: "1px solid var(--border)",
    borderRadius: "var(--radius)",
    color: "var(--text)",
    padding: "6px 10px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
